import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=0718dbd8&"
import script from "./Ward.vue?vue&type=script&lang=js&"
export * from "./Ward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports